<template>
  <div
    class="pb-2 slide-image"
    :class="{
      'has-bg-image': isLayoutFullScreen,
    }"
  >
    <div class="flex image-body">
      <img
        alt
        :src="slideActive.image.xLarge"
        v-if="isLayoutCenter && slideActive.image"
      >
    </div>

    <div
      class="pb-0 caption"
      v-if="slideActive.subheading && slideActive.subheading.trim() !== ''"
      :class="{
        'small-text': isLayoutCenter && isSubheadingTooLong,
        'white': isLayoutFullScreen && slideActive.image && isTextColourLight,
        'black': isLayoutFullScreen && slideActive.image && !isTextColourLight,
      }"
    >
      <div class="caption-text" :inner-html.prop="slideActive.subheading | sanitize(true)" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ImageContent',
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters(['isTextColourLight']),
    isSubheadingTooLong() {
      return this.slideActive.subheading && this.slideActive.subheading.length > 64
    },
    isLayoutCenter() {
      return this.slideActive.imageType === 'default'
    },
    isLayoutFullScreen() {
      return this.slideActive.imageType === 'background'
    },
  },
}
</script>

<style lang="scss" scoped>
.has-bg-image {
  // This is to fix caption width when img = background
  width: unset !important;
  height: unset !important;
}

.slide-image img {
  border-radius: 4px;
  height: 100%;
  display: block;
  margin: 0 auto;
  width: 100%;
  object-fit: contain;
}
</style>
